import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSelectedPatient, getPatient } from '../../redux/Patient/PatientAction';
import ClosePatient from '../SideBarRight/ClosePatient';
import { useIndexedDB } from 'react-indexed-db';
import useForbidden from '../../hooks/useForbidden';
import CustomSideBar from '../CustomSideBar';
import useRoutes from '../../Routes/useRoutes';

const PatientFileNav = () => {
    const dispatch = useDispatch();
    const params = useParams();
    // const history = useHistory();
    const patient = useSelector((state) => state.patient.patient.profile);
    const { notAllowed } = useForbidden();
    const { handleClosePatient } = ClosePatient();
    const { patientRoutes } = useRoutes();
    const { deleteRecord } = useIndexedDB('patients');
    const commonPath = `/${params.clinicId}/patient/${params.id}`;

    useEffect(() => {
        if (notAllowed) {
            deleteRecord(+params?.id);
            dispatch(deleteSelectedPatient(+params?.id));
            // history.replace(`/${params.clinicId}/patients`);
        } else if (params?.id) {
            dispatch(getPatient(params?.id));
        }
    }, [params?.id, notAllowed]);

    return (
        <>
            <CustomSideBar
                handleClosePatient={handleClosePatient}
                isPatientPage
                data={patientRoutes}
                patient={patient}
                commonPath={commonPath}
            />
        </>
    );
};

export default PatientFileNav;
